import { Typography } from "antd";
import React from "react";
import useResponsive from "../../utils/hooks/useResponsive";
import "./customToggle.css";

interface CustomToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  content?: string;
}

export const CustomToggle: React.FC<CustomToggleProps> = ({
  checked,
  onChange,
  content,
}) => {
  const { isTablet } = useResponsive();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "8px",
        alignItems: "center",
      }}
    >
      <div
        className={`custom-toggle${checked ? " checked" : ""}`}
        onClick={() => onChange(!checked)}
        role="button"
        tabIndex={0}
        aria-checked={checked}
        style={{ outline: "none" }}
      >
        <div className="custom-toggle-bg" />
        <div className="custom-toggle-circle" />
      </div>
      {content && (
        <Typography
          style={{
            fontSize: isTablet ? 12 : 14,
            fontWeight: 400,
            color: "white",
          }}
        >
          {content}
        </Typography>
      )}
    </div>
  );
};
